/**
 * window.DKSampleConfirm — shared material sample picker for Wallpaper and
 * Wall Mural products.
 *
 * Usage:
 *   DKSampleConfirm.open({
 *     materials: [{ id, label, description, popular }],
 *     currentId,
 *     priceText: '$6',
 *     onSelect(id),
 *     onConfirm(id),
 *   });
 */
(function () {
  var SEL = '.dk-sampleconfirm__overlay';
  var previousFocus = null;
  var closeTimer = null;

  function materialHint(material) {
    if (material.sampleDescription) return material.sampleDescription;

    var key = String(material.id || material.label || '').toLowerCase();
    if (key.indexOf('textured peel') !== -1) return 'Self-adhesive · fine canvas texture';
    if (key.indexOf('textile') !== -1) return 'Premium textile finish · hospitality-grade';
    if (key.indexOf('peel') !== -1) return 'Smooth, self-adhesive · removable';
    if (key.indexOf('textured') !== -1) return 'Rich tactile finish · helps hide minor wall flaws';
    if (key.indexOf('non-woven') !== -1 || key.indexOf('non woven') !== -1) return 'Smooth matte surface · paste required';

    var description = String(material.description || 'Material and print quality sample');
    return description.replace(/^[^:]+:\s*/, '');
  }

  function focusableElements(sheet) {
    return Array.prototype.slice.call(
      sheet.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return el.offsetParent !== null; });
  }

  function close(restoreFocus) {
    var overlay = document.querySelector(SEL);
    document.removeEventListener('keydown', onKey);
    document.body.classList.remove('dk-sampleconfirm-open');

    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    if (overlay) {
      overlay.classList.remove('is-open');
      if (restoreFocus === false) {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      } else {
        closeTimer = setTimeout(function () {
          if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
          closeTimer = null;
        }, 200);
      }
    }

    if (restoreFocus !== false && previousFocus && document.contains(previousFocus)) {
      previousFocus.focus({ preventScroll: true });
    }
    previousFocus = null;
  }

  function onKey(event) {
    var overlay = document.querySelector(SEL);
    if (!overlay) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }

    if (event.key !== 'Tab') return;
    var sheet = overlay.querySelector('.dk-sampleconfirm');
    var focusable = sheet ? focusableElements(sheet) : [];
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function open(opts) {
    opts = opts || {};
    var materials = opts.materials || [];
    if (!materials.length) {
      if (opts.onConfirm) opts.onConfirm(opts.currentId);
      return;
    }

    close(false);
    previousFocus = document.activeElement;

    var chosen = opts.currentId || materials[0].id;
    var price = opts.priceText || '$6';

    var overlay = document.createElement('div');
    overlay.className = 'dk-sampleconfirm__overlay';

    var sheet = document.createElement('div');
    sheet.className = 'dk-sampleconfirm';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-labelledby', 'DkSampleConfirmTitle');
    sheet.setAttribute('aria-describedby', 'DkSampleConfirmIntro DkSampleConfirmNotice');

    sheet.innerHTML =
      '<button type="button" class="dk-sampleconfirm__close" aria-label="Close sample dialog">' +
        '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button>' +
      '<header class="dk-sampleconfirm__header">' +
        '<p class="dk-sampleconfirm__eyebrow">Material sample</p>' +
        '<h3 class="dk-sampleconfirm__title" id="DkSampleConfirmTitle">Order a sample</h3>' +
        '<p class="dk-sampleconfirm__sub" id="DkSampleConfirmIntro">Choose a material to see the color, print and finish in person.</p>' +
        '<p class="dk-sampleconfirm__meta">' +
          '<span class="dk-sampleconfirm__size">9&Prime; &times; 20&Prime; <span>(23 &times; 51 cm)</span></span>' +
          '<span class="dk-sampleconfirm__dot" aria-hidden="true">&middot;</span>' +
          '<span><strong class="dk-sampleconfirm__price"></strong> each</span>' +
        '</p>' +
      '</header>' +
      '<div class="dk-sampleconfirm__chips" role="radiogroup" aria-label="Choose sample material"></div>' +
      '<aside class="dk-sampleconfirm__notice" id="DkSampleConfirmNotice">' +
        '<svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 10v6M12 7h.01"/></svg>' +
        '<div><strong>For quality review only</strong>' +
        '<p>Samples show a cropped section of the artwork and may include partial elements or text. They are intended only to evaluate color, print quality and material feel&mdash;not for installation or display.</p></div>' +
      '</aside>' +
      '<button type="button" class="dk-sampleconfirm__cta">Add sample to cart <span aria-hidden="true">&middot;</span> <span class="dk-sampleconfirm__cta-price"></span></button>';

    sheet.querySelector('.dk-sampleconfirm__price').textContent = price;
    sheet.querySelector('.dk-sampleconfirm__cta-price').textContent = price;

    var chipsWrap = sheet.querySelector('.dk-sampleconfirm__chips');

    function renderChips(focusChosen) {
      chipsWrap.innerHTML = '';
      materials.forEach(function (material, index) {
        var isChosen = material.id === chosen;
        var isPopular = material.popular === true || material.isPopular === true || (index === 0 && material.popular !== false);
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'dk-sampleconfirm__chip' + (isChosen ? ' is-active' : '');
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', isChosen ? 'true' : 'false');
        button.tabIndex = isChosen ? 0 : -1;
        button.dataset.materialId = material.id;

        var content = document.createElement('span');
        content.className = 'dk-sampleconfirm__chip-content';

        var name = document.createElement('span');
        name.className = 'dk-sampleconfirm__chip-name';
        name.textContent = material.label || material.id;

        var hint = document.createElement('span');
        hint.className = 'dk-sampleconfirm__chip-hint';
        hint.textContent = materialHint(material);

        var selector = document.createElement('span');
        selector.className = 'dk-sampleconfirm__selector';
        selector.setAttribute('aria-hidden', 'true');
        selector.innerHTML = '<svg viewBox="0 0 16 16"><path d="M3.5 8.2 6.6 11l5.9-6"/></svg>';

        content.appendChild(name);
        content.appendChild(hint);
        button.appendChild(content);
        button.appendChild(selector);

        if (isPopular) {
          var badge = document.createElement('span');
          badge.className = 'dk-sampleconfirm__popular';
          badge.textContent = 'Most popular';
          button.appendChild(badge);
        }

        button.addEventListener('click', function () {
          chosen = material.id;
          renderChips(true);
          if (opts.onSelect) opts.onSelect(material.id);
        });
        button.addEventListener('keydown', function (event) {
          var nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % materials.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + materials.length) % materials.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = materials.length - 1;
          else return;

          event.preventDefault();
          chosen = materials[nextIndex].id;
          renderChips(true);
          if (opts.onSelect) opts.onSelect(chosen);
        });
        chipsWrap.appendChild(button);
      });

      if (focusChosen) {
        var active = chipsWrap.querySelector('.dk-sampleconfirm__chip.is-active');
        if (active) active.focus({ preventScroll: true });
      }
    }
    renderChips(false);

    sheet.querySelector('.dk-sampleconfirm__cta').addEventListener('click', function () {
      var id = chosen;
      close();
      if (opts.onConfirm) opts.onConfirm(id);
    });
    sheet.querySelector('.dk-sampleconfirm__close').addEventListener('click', function () { close(); });
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) close();
    });
    document.addEventListener('keydown', onKey);

    overlay.appendChild(sheet);
    document.body.appendChild(overlay);
    document.body.classList.add('dk-sampleconfirm-open');

    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      var selected = sheet.querySelector('.dk-sampleconfirm__chip.is-active');
      (selected || sheet.querySelector('.dk-sampleconfirm__close')).focus({ preventScroll: true });
    });
  }

  window.DKSampleConfirm = { open: open, close: close };
})();
